import { sysLabels } from './../data/translations';
import { chapterTextLabel } from "./constants";
import { Language } from "./constants";

export const chapterLabel = (chapter: string, language: string | Language) => {
    return chapter.replace(sysLabels[chapterTextLabel]['EN'], 
        sysLabels[chapterTextLabel][
            ((language as unknown) as Language).short || 'EN']
    );
}

export const chapterNum = (chapter: string): number => {
  const parts = chapter.split('_');
  const num = parseInt(parts[1], 10);
  return num - 1;
};